import * as React from 'react';

import classNames from 'classnames';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'mate... Remove this comment to see the full error message
import LightTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'mate... Remove this comment to see the full error message
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import PropTypes from 'prop-types';
import { compose } from 'recompose';

import type { UserData } from 'js/lib/user';
import { get as getUser, isAuthenticatedUser, isPoweruser, isSuperuser } from 'js/lib/user';

import Naptime from 'bundles/naptimejs';
import PrivilegedAuths from 'bundles/naptimejs/resources/privilegedAuths.v1';

import 'css!./__styles__/InternalTool';
import 'css!bundles/internal-common/styl/materialism';

import type { MenuItemProps } from './LeftNav';
import LeftNav from './LeftNav';

type PropsFromCaller = React.PropsWithChildren<{
  name: string;
  menuItems?: MenuItemProps[];
  noLeftNav?: boolean;
}>;
type Props = PropsFromCaller;

const userToProfile = (userData: UserData) => ({
  name: userData.full_name,
  emailAddress: userData.email_address,
});

/**
 * A secure wrapper component for internal tools that provides authentication, theming, and navigation.
 * This component ensures that only authenticated users with appropriate permissions can access the internal tool.
 * It provides a consistent layout with an optional left navigation bar and applies Material-UI theming.
 */
class SecureInternalTool extends React.Component<Props> {
  static childContextTypes = {
    muiTheme: PropTypes.object,
  };

  getChildContext() {
    return {
      muiTheme: getMuiTheme(LightTheme),
    };
  }

  render() {
    const profile = userToProfile(getUser());
    return (
      <div className="rc-SecureInternalTool internal-tool">
        {!this.props.noLeftNav && <LeftNav profile={profile} menuItems={this.props.menuItems} />}
        <div className={classNames({ right: !this.props.noLeftNav })}>{this.props.children}</div>
      </div>
    );
  }
}

export default compose<Props, PropsFromCaller>(
  Naptime.createContainer(() => {
    if (isAuthenticatedUser() && (isSuperuser() || isPoweruser())) {
      return {};
    }

    return {
      privilegedAuths: PrivilegedAuths.me({ fields: ['outsourcingPermissions'] }),
    };
  })
)(SecureInternalTool);
